const colorBtns = [
    {
        color: '#B38BFA'
    },
    {
        color: '#FF79F2'
    },
    {
        color: '#43E6FC'
    },
    {
        color: '#F19576'
    },
    {
        color: '#0047FF'
    },
    {
        color: '#6691FF'
    }
]

export default colorBtns;